import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

import EFVideoPlayer from '@/components/UI/svg/mm100/Icon/EFVideoPlayer';

import EFVideo from '@/components/UI/EFVideo';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function Comp({ callBack, video }: any) {
    const { useLang, useEffect, useState, useRouter, gtm } = useGlobal();
    const { t } = useLang('ecoflowpowerkitsseries');
    const { locale } = useRouter();
    const [videoEnterA, setVideoEnterA] = useState(false);
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const videoSourceMap: any = {
        us: 'https://www.youtube.com/embed/PgJBYhaNjlo',
        cn: {
            SD: 'https://videos.ecoflow.com/f403779199b149048644c5a86cb5a798/607be7e1cc2746009784dcfc3a21fe74-9075ea9f6dda36d15deee22d3c9b33a6-fd.mp4',
            HD: 'https://videos.ecoflow.com/f403779199b149048644c5a86cb5a798/607be7e1cc2746009784dcfc3a21fe74-1ac38e814bb3020a0b7dedbabb15f7d0-sd.mp4',
            '2K': 'https://videos.ecoflow.com/original/workflow/2d943068-1842c317666-0004-9c91-e6d-40030.mp4',
        },
    };

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: `.listB`,
            offset: -100, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '300%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        sceneA1.on('enter', function () {
            setVideoEnterA(true);
        });

        AniContainer.addScene(sceneA1);
    }, []);

    const playerVideo = (position: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'EcoFlow Power Kits - Compact and Integrated Power Solution',
            position,
        });
        setShowEFVideoModal(true);
    };

    return (
        <div className={`${css.listB} listB`}>
            <div className={`kit-inter`}>
                <div className="kit-inner-box0">
                    <h2 className="title">{t('presale.product.listB_title')}</h2>
                    <p className="desc">{t('presale.product.listB_desc')}</p>
                    <span className="learn" onClick={() => callBack('app')}>
                        {t('presale.product.listB_learn')}
                        <span className="icon">+</span>
                    </span>
                </div>
                <div className="kit-inter-box1">
                    <div className="kit-l">{videoEnterA && <EFVideo sources={video} className="video" width={1120} height={640} />}</div>
                    <div className="kit-r">
                        <li className="kit-msg">{t('presale.product.listB_msg1')}</li>
                        <li className="kit-msg">{t('presale.product.listB_msg2')}</li>
                        <li className="kit-msg">{t('presale.product.listB_msg3')}</li>
                        <div className="watch-video-btn" onClick={() => playerVideo(t('presale.product.listB_msg1'))}>
                            {t('presale.product.watch_video')}
                            <EFVideoPlayer className="icon" color="#FFF" />
                        </div>
                    </div>
                </div>
            </div>
            <EFVideoModal
                visible={showEFVideoModal}
                source={videoSourceMap[locale] || videoSourceMap.us}
                onClose={() => setShowEFVideoModal(false)}
                playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
            />
        </div>
    );
}
